import React, { useState, useEffect } from 'react';
import classNames from 'classnames';

function ChoiceTopColor({ selectedData, modelTop, modelTopColor, setModelTopColor}) {
	const [activeIndex, setActiveIndex] = useState(0);

	const handleColorSelection = (item, itemIndex) => {
		setActiveIndex(itemIndex);
		setModelTopColor(() => item);
	}

	// useEffect(() => {
	// }, [modelTopColor]);
	

	if (!!!modelTop ) {
		return null;
	}

	return (
		<div className="choices">
			<ul>
				{modelTop.colors?.list.map((item, index) => (
					<li key={index}>
						<a
							onClick={(e) => {
								e.preventDefault();
								handleColorSelection(item, index)
							}}
							className={classNames('preview decor-checkbox', { 'is-active': activeIndex === index })}
							href={item.model}
						>
							<picture className="preview__media">
								<img src={item.preview} alt={item.name} />
							</picture>

							<div className="preview__content">
								<h6>{item.name}</h6>
							</div>
						</a>
					</li>
				))}
			</ul >
		</div >
	);
}

export default ChoiceTopColor;